var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeviceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 29,
    viewBox: "0 0 34 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 29,
    rx: 3.91304,
    transform: "matrix(-1 0 0 1 34 0)",
    fill: "#96A5B8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3496 19.1665C25.3496 19.3768 25.2922 19.5716 25.1775 19.751C25.0627 19.9303 24.9065 20.0695 24.7088 20.1685L17.0191 23.8794C16.9362 23.9165 16.8533 23.9443 16.7705 23.9629C16.6876 23.9814 16.6015 23.9938 16.5122 24C16.2891 24 16.0882 23.9474 15.9097 23.8423C15.7311 23.7371 15.5877 23.5825 15.4793 23.3784L8.77471 10.3252C8.69182 10.152 8.65037 9.98812 8.65037 9.8335C8.65037 9.62321 8.70776 9.42839 8.82253 9.24902C8.9373 9.06966 9.09352 8.9305 9.29118 8.83154L16.9809 5.12061C17.1594 5.0402 17.3284 5 17.4878 5C17.7109 5 17.915 5.05566 18.0999 5.16699C18.2848 5.27832 18.4251 5.42985 18.5207 5.62158L25.2253 18.6748C25.3082 18.848 25.3496 19.0119 25.3496 19.1665ZM16.5409 22.7847L24.0967 19.1387L17.4591 6.21533L9.90329 9.86133L16.5409 22.7847ZM20.6249 19.2314L18.7024 20.1592L18.1573 19.0923L20.0797 18.1646L20.6249 19.2314ZM23.1211 8.21924L22.3273 8.97998L21.4665 8.14502L23.7333 5.94629L26 8.14502L25.1392 8.97998L24.3454 8.21924V10.9375H23.1211V8.21924ZM10.8789 20.7808L11.6727 20.02L12.5335 20.855L10.2667 23.0537L8 20.855L8.86079 20.02L9.65462 20.7808V18.0625H10.8789V20.7808Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceIcon);
export default __webpack_public_path__ + "static/media/deviceIcon.49bfeb6d786843d000b2754d0ad95773.svg";
export { ForwardRef as ReactComponent };